import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimplePanoptixPS30 = () => {
  console.log('🎯 SimplePanoptixPS30 component loading');
  
  const product = findProductById("panoptix-ps30-down");
  
  if (!product) {
    console.error('Product not found:', "panoptix-ps30-down");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="panoptix-ps30-down"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimplePanoptixPS30; 